module.exports = __webpack_public_path__ + "assets/HKNova-Thin.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Thin.svg
// module id = 151
// module chunks = 0